import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconWatch = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    fill="none"
    viewBox="0 0 14 15"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#000"
      fillOpacity={0.6}
      d="M6.344 4.031c0-.355.273-.656.656-.656.355 0 .656.3.656.656v3.39L9.98 8.954c.301.219.383.629.165.93a.628.628 0 0 1-.903.164l-2.625-1.75a.673.673 0 0 1-.273-.547V4.031ZM7 .75c3.855 0 7 3.145 7 7 0 3.883-3.145 7-7 7-3.883 0-7-3.117-7-7 0-3.855 3.117-7 7-7Zm-5.688 7A5.683 5.683 0 0 0 7 13.438c3.117 0 5.688-2.543 5.688-5.688 0-3.117-2.57-5.688-5.688-5.688-3.145 0-5.688 2.57-5.688 5.688Z"
    />
  </svg>
));
export default SvgIconWatch;
